<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入客户名称或公司名称"
            v-model="searchValue"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="clientList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { pageList } from '@/api/client'
import TzTable from '@/components/tz-table/Index.vue'
export default {
  components: {
    TzTable
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      searchValue: '',
      clientList: [],
      columns: [
        {
          field: 'name',
          title: '客户名称'
        },
        {
          field: 'company',
          title: '公司名称'
        },
        {
          field: 'mobile',
          title: '手机号'
        },
        {
          field: 'count',
          title: '检测数量'
        },

        {
          field: 'companyAddr',
          title: '公司地址'
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    // 列表
    getList() {
      let dictparams = {
        search: this.searchValue,
        pageSize: this.size,
        pageNum: this.page
      }
      pageList(dictparams).then((res) => {
        if (res.code == 200) {
          let clientArr = res.data.records
          this.total = res.data.total
          this.clientList = clientArr.map((item) => {
            return {
              id: item.id,
              mobile: item.mobile,
              company: item.company,
              count: item.count,
              name: item.name,
              companyAddr: item.companyAddr
            }
          })
        }
      })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getList()
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style></style>
